import { toTime } from "@hex-insights/core";
import { MessageAvailabilityPeriod, MessageAvailabilityPeriodTimingFragment } from "../../../Utilities";
import { MessageAvailabilityPeriodFormat } from "../../Format";

export function getUserTodayAvailability(messageAvailabilityPeriods: MessageAvailabilityPeriodTimingFragment[]) {
	// TODO handling for muliple periods in a day, consideration for after end of last period, show next period, etc
	const currentDayOfWeek = new Date().getDay();
	for (let i = 0; i < messageAvailabilityPeriods.length; i++) {
		const period = messageAvailabilityPeriods[i];
		if (period.dayOfWeek !== currentDayOfWeek) {
			continue;
		}
		return `Available today: ${MessageAvailabilityPeriodFormat.Fields.startTimeMinutes(
			period.startTimeMinutes,
		)} - ${MessageAvailabilityPeriodFormat.Fields.endTimeMinutes(period.endTimeMinutes)}`;
	}
	return "Not available today";
}

/**
 * Determines if a user is currently available based on their availability periods.
 *
 * @note Users without availability set should not have their availability status shown (this function does not consider
 * that).
 *
 * @param messageAvailabilityPeriods The user's availability periods.
 */
export function isUserAvailable(messageAvailabilityPeriods: MessageAvailabilityPeriodTimingFragment[]) {
	const currentDayOfWeek = new Date().getDay();
	const currentTimeMinutes = toTime("minute");
	for (let i = 0; i < messageAvailabilityPeriods.length; i++) {
		const period = messageAvailabilityPeriods[i];
		if (period.dayOfWeek !== currentDayOfWeek) {
			continue;
		}
		if (period.startTimeMinutes <= currentTimeMinutes && currentTimeMinutes <= period.endTimeMinutes) {
			return true;
		}
	}
	return false;
}

/**
 * Filters the list of availability periods to only include periods that are available today.
 *
 * @param messageAvailabilityPeriods The periods to filter.
 */
export function filterTodayPeriods<T extends Pick<MessageAvailabilityPeriod, "dayOfWeek">>(
	messageAvailabilityPeriods: T[],
) {
	const currentDayOfWeek = new Date().getDay();
	return messageAvailabilityPeriods.filter((period) => period.dayOfWeek === currentDayOfWeek);
}
